<script>
export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div class="border-b border-solid bg-n-background border-n-weak">
    <div class="w-full px-6 pt-5 pb-0 mx-auto max-w-7xl">
      <div class="flex items-center gap-3">
        <slot name="badge" />
        <div class="min-w-0">
          <h2
            class="mb-0 text-xl font-semibold tracking-tight truncate text-n-slate-12"
          >
            {{ headerTitle }}
          </h2>
          <p
            v-if="headerContent"
            class="w-full mt-1 mb-0 text-sm text-n-slate-11"
          >
            {{ headerContent }}
          </p>
        </div>
        <div class="ltr:ml-auto rtl:mr-auto">
          <slot name="actions" />
        </div>
      </div>
      <div class="mt-3">
        <slot />
      </div>
    </div>
  </div>
</template>
